import React, { useCallback, useState } from "react";
import { Alert, Snackbar } from "@mui/material";
import { useForgotPasswordForm } from "./useForgotPassword";
import {
  BERLIN_LOGO_LOCAL,
  BERLIN_LOGO_URL,
} from "../../constants/brandAssets";
import logoFallback from "../../assets/Images/element-wordmark-black.svg";
import heroDashboard from "../../assets/Images/login-dashboard-preview.png";
import { PageSubtitle } from "./style";
import {
  ForgotLink,
  FormInner,
  FormSection,
  HeroContent,
  HeroHeadline,
  HeroImageWrap,
  LeftPanel,
  LoginPage,
  LoginTextField,
  LogoBar,
  RightPanel,
  SignInButton,
  WelcomeTitle,
} from "../log-in/style";

const ForgotPassword = () => {
  const { alert, isLoading, formik, handleClose } = useForgotPasswordForm();
  const [logoSrc, setLogoSrc] = useState(BERLIN_LOGO_URL);

  const handleLogoError = useCallback(() => {
    setLogoSrc((current) => {
      if (current === BERLIN_LOGO_URL) return BERLIN_LOGO_LOCAL;
      if (current === BERLIN_LOGO_LOCAL) return logoFallback;
      return current;
    });
  }, []);

  return (
    <LoginPage>
      <Snackbar
        open={alert.open}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleClose}
          severity={alert.severity}
          sx={{ width: "100%" }}
        >
          {alert.message}
        </Alert>
      </Snackbar>

      <LeftPanel>
        <LogoBar>
          <img
            className="login-logo"
            src={logoSrc}
            alt="Berlin"
            onError={handleLogoError}
          />
        </LogoBar>

        <FormSection>
          <FormInner>
            <WelcomeTitle>Forgot password?</WelcomeTitle>
            <PageSubtitle>
              Enter your email and we&apos;ll send you a link to reset your
              password.
            </PageSubtitle>

            <form onSubmit={formik.handleSubmit}>
              <LoginTextField
                id="email"
                name="email"
                variant="outlined"
                fullWidth
                placeholder="Email"
                value={formik.values.email}
                onChange={formik.handleChange}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
              />
              <SignInButton
                variant="contained"
                fullWidth
                type="submit"
                disabled={isLoading}
              >
                {isLoading ? "Sending..." : "Send reset link"}
              </SignInButton>
              <ForgotLink to="/">Back to log in</ForgotLink>
            </form>
          </FormInner>
        </FormSection>
      </LeftPanel>

      <RightPanel>
        <HeroContent>
          <HeroHeadline>
            Total visibility.
            <br />
            Every client, requirement,
            <br />
            and hire — in one place.
          </HeroHeadline>
          <HeroImageWrap>
            <img src={heroDashboard} alt="Berlin Jobs dashboard preview" />
          </HeroImageWrap>
        </HeroContent>
      </RightPanel>
    </LoginPage>
  );
};

export default ForgotPassword;
